import { useMemo } from 'react'

const useMultipleCostInvoiceCalculateAmounts = ({
  form,
  lines,
  discountLines,
  extraCostsLines
}) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalAgreedPrice = useMemo<number>(() => lines?.reduce<number>(
    (prev: number, next: {agreedPrice ?: number|string}) => {
      const currentValue = next?.agreedPrice ? parseFloat(next.agreedPrice as string) : 0
      return prev + currentValue
    }, 0
  ), [lines])
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalAmountOnInvoice = useMemo<number>(() => lines.reduce<number>((prev: number, next: {priceOnInvoice ?: number|string}) => {
    const currentValue = next?.priceOnInvoice ? parseFloat(next.priceOnInvoice as string) : 0
    return prev + currentValue
  }, 0), [lines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalAmountOnInvoiceIncVat = useMemo<number>(() => lines.reduce<number>((prev: number, next: {totalAmount ?: number|string}) => {
    const currentValue = next?.totalAmount ? parseFloat(next.totalAmount as string) : 0
    return prev + currentValue
  }, 0), [lines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalExtraCosts = useMemo<number>(() => extraCostsLines.reduce<number>((prev: number, next: {amount ?: number|string}) => {
    const currentValue = next?.amount ? parseFloat(next.amount as string) : 0
    return prev + currentValue
  }, 0), [extraCostsLines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalExtraCostsVat = useMemo<number>(() => extraCostsLines.reduce<number>((prev: number, next: {vatAmount ?: number|string}) => {
    const currentValue = next?.vatAmount ? parseFloat(next.vatAmount as string) : 0
    return prev + currentValue
  }, 0), [extraCostsLines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalLineVat = useMemo<number>(() => lines.reduce<number>((prev: number, next: {vatAmount ?: number|string}) => {
    const currentValue = next?.vatAmount ? parseFloat(next.vatAmount as string) : 0

    return prev + currentValue
  }, 0), [lines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalDiscount = useMemo<number>(() => discountLines.reduce<number>((prev: number, next: {amount ?: number|string}) => {
    const currentValue = next?.amount ? parseFloat(next.amount as string) : 0
    return prev + currentValue
  }, 0), [discountLines])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const totalExtraCostsIncVat = useMemo<number>(() => extraCostsLines.reduce<number>((prev: number, next: {totalAmount ?: number|string}) => {
    const currentValue = next?.totalAmount ? parseFloat(next.totalAmount as string) : 0
    return prev + currentValue
  }, 0), [extraCostsLines])

  const calculateTotalDiscount = useMemo(() => {
    let totalDiscountAmount = 0

    discountLines.forEach((line) => {
      totalDiscountAmount += line.totalAmount
    })

    return totalDiscountAmount
  }, [lines, totalExtraCosts, discountLines, totalAmountOnInvoice, totalExtraCosts])

  const applyType = 1
  const totalAgreedPricePlusExtraCosts = totalAgreedPrice + totalExtraCosts
  const irpfPercentage = (form?.irpf ? parseFloat(form?.irpf) : 0) / 100
  const totalIRPF = ((totalAmountOnInvoice + totalExtraCosts) - totalDiscount) * irpfPercentage
  const totalDiscountVat = (calculateTotalDiscount - totalDiscount)

  const totalVatAmount = totalLineVat - totalDiscountVat + totalExtraCostsVat
  const totalEndAmountToPay = (totalAmountOnInvoice + totalExtraCosts) + totalVatAmount
              - (totalIRPF) - (totalDiscount)

  return {
    totalAgreedPrice: totalAgreedPrice * applyType,
    totalAmountOnInvoice: totalAmountOnInvoice * applyType,
    totalExtraCosts: totalExtraCosts * applyType,
    calculateTotalDiscount,
    totalAgreedPricePlusExtraCosts: totalAgreedPricePlusExtraCosts * applyType,
    totalAmountOnInvoiceIncVat: totalAmountOnInvoiceIncVat * applyType,
    totalExtraCostsIncVat: totalExtraCostsVat * applyType,
    totalIRPF: totalIRPF * applyType * -1,
    totalEndAmountToPay: totalEndAmountToPay * applyType,
    totalDiscount: totalDiscount * applyType * -1,
    totalVatAmount: totalVatAmount * applyType
  }
}

export default useMultipleCostInvoiceCalculateAmounts
